<template lang="pug">
  el-dialog(title="编辑培训班详情" :visible.sync="visible" width="900px" :append-to-body="true" :modal-append-to-body="false" :close-on-click-modal="false" @close="handleClose")
    
    el-form(ref="editFormRef" :model="form" :rules="rules" label-width="100px")
      el-row(:gutter="16")
        el-col(:span="12")
          el-form-item(label="培训班名称" prop="className")
            el-input(v-model="form.className" placeholder="请输入培训班名称")
        el-col(:span="12")
          el-form-item(label="容量" prop="capacity" required)
            el-input-number(v-model="form.capacity" :min="1" :max="50" style="width:100%;")
        el-col(:span="12")
          el-form-item(label="教练" prop="coachId")
            el-select(v-model="form.coachId" placeholder="请选择教练" filterable style="width:100%;" @change="onCoachChange")
              el-option(v-for="coach in coachList" :key="coach.id" :label="coach.name + (coach.coachLevel ? ' · PTR ' + coach.coachLevel : '')" :value="coach.id")
            div(style="color:#999;font-size:12px;margin-top:4px;") 选择后自动回填全部课程，仍可在下方逐节调整。
      // 课程信息
      div(style="margin-top:20px;font-weight:bold;font-size:16px;") 课程信息
      el-table(:data="form.courses" border style="margin-top:10px;")
        el-table-column(label="课程" width="140")
          template(slot-scope="scope")
            div {{ scope.row.courseCode }}
            div(style="color:#999;font-size:12px;") 第{{ scope.$index + 1 }}节
        el-table-column(label="日期" width="160")
          template(slot-scope="scope")
            el-date-picker(v-model="scope.row.date" type="date" value-format="yyyy-MM-dd" style="width:100%;")
        el-table-column(label="时段" width="220")
          template(slot-scope="scope")
            el-time-picker(v-model="scope.row._startTime" value-format="HH:mm" placeholder="开始" style="width:46%;" @change="onTimeChange(scope.row, 'start')")
            span(style="margin: 0 4px;") -
            el-time-picker(v-model="scope.row._endTime" value-format="HH:mm" placeholder="结束" style="width:46%;" @change="onTimeChange(scope.row, 'end')")
        el-table-column(label="场地编号" width="140")
          template(slot-scope="scope")
            el-input(v-model="scope.row.venueCode" placeholder="场地编号")
        el-table-column(label="教练" width="160")
          template(slot-scope="scope")
            el-select(v-model="scope.row.coachId" placeholder="请选择教练" filterable clearable style="width:100%;")
              el-option(v-for="coach in coachList" :key="coach.id" :label="coach.name" :value="coach.id")
    span.dialog-footer(slot="footer")
      el-button(@click="handleClose") 取消
      el-button(type="primary" :loading="loading" @click="submit") 保存
  </el-dialog>
</template>

<script>
export default {
  name: 'EditClassDialog',
  props: {
    coachList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      classData: {},
      form: {
        className: '',
        capacity: 1,
        timeSlot: '',
        coachId: null,
        venueCode: '',
        courses: []
      },
      rules: {
        className: [{ required: true, message: '请输入培训班名称', trigger: 'blur' }],
        capacity: [{ required: true, message: '请输入容量', trigger: 'blur' }],
        timeSlot: [{ required: true, message: '请输入上课时段', trigger: 'blur' }],
        venueCode: [{ required: true, message: '请输入场地编号', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init (cls) {
      this.classData = cls || {}
      this.initForm()
      this.visible = true
    },
    initForm () {
      const cls = this.classData
      this.form = {
        className: cls.className || '',
        capacity: cls.capacity || 1,
        timeSlot: cls.timeSlot || '',
        coachId: cls.coachId || null,
        venueCode: cls.venueCode || '',
        courses: (cls.courses || []).map(c => this.splitTimeSlot({ ...c }))
      }
      if (!this.form.courses.length) {
        this.generateDefaultCourses()
      }
    },
    splitTimeSlot (course) {
      if (course && course.timeSlot && (!course._startTime && !course._endTime)) {
        const parts = String(course.timeSlot).split('-')
        course._startTime = parts[0] || null
        course._endTime = parts[1] || null
      }
      return course
    },
    onTimeChange (row, field) {
      let s = row._startTime || ''
      let e = row._endTime || ''
      if (s && e && s >= e) {
        this.$message.warning('结束时间必须大于开始时间')
        if (field === 'start') {
          row._startTime = ''
          s = ''
        } else {
          row._endTime = ''
          e = ''
        }
      }
      row.timeSlot = s && e ? (s + '-' + e) : (s || e)
    },
    generateDefaultCourses () {
      const courseCount = 8
      const startDate = new Date()
      const timeSlot = this.form.timeSlot || ''
      const venueCode = this.form.venueCode || ''
      const coachId = this.form.coachId || null
      const classCode = this.classData.classCode || ''
      const courses = []
      for (let i = 0; i < courseCount; i++) {
        const d = new Date(startDate)
        d.setDate(d.getDate() + i * 7)
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        courses.push(this.splitTimeSlot({
          courseCode: `${classCode}-${String(i + 1).padStart(2, '0')}`,
          date: `${year}-${month}-${day}`,
          timeSlot: timeSlot,
          venueCode: venueCode,
          coachId: coachId
        }))
      }
      this.form.courses = courses
    },
    onCoachChange (val) {
      this.form.courses.forEach(c => {
        c.coachId = val
      })
    },
    submit () {
      for (const c of this.form.courses) {
        const s = c._startTime || ''
        const e = c._endTime || ''
        if (s && e && s >= e) {
          this.$message.warning('时段设置有误：结束时间必须大于开始时间')
          return
        }
        if ((s && !e) || (!s && e)) {
          this.$message.warning('请同时填写开始和结束时间')
          return
        }
      }
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) return
        this.loading = true
        const coach = this.coachList.find(c => c.id === this.form.coachId)
        const result = {
          className: this.form.className,
          capacity: this.form.capacity,
          timeSlot: this.form.timeSlot,
          coachId: this.form.coachId,
          coachName: coach ? coach.name : '',
          venueCode: this.form.venueCode,
          courses: this.form.courses
        }
        this.$emit('confirm', result)
        this.visible = false
        this.loading = false
      })
    },
    handleClose () {
      if (this.$refs.editFormRef) {
        this.$refs.editFormRef.clearValidate()
      }
      this.visible = false
    }
  }
}
</script>
